module.exports = __webpack_public_path__ + "img/wu.00c6beeb.png";